import { Box } from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSession } from "redux/services";
import * as chatActions from "redux/actions/chats";
import Loader from "component/Loader";
import ai from "assets/images/ai.png";
import SendButton from "component/SendButton";
import { getTextColor } from "redux/utils";

const Index = ({ widget, id }) => {
  const [chatData, setChatData] = useState("");
  const { creating } = useSelector((state) => state.chats);
  const [brandColour, setBrandColour] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (widget !== null || undefined) {
      const colour = getTextColor(widget?.bot_background);
      setBrandColour(colour);
    }
  }, [widget, widget?.bot_background]);

  const handleInputData = (e) => {
    setChatData(e?.target?.value);
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleClick();
    }
  };

  const handleClick = (value) => {
    let sessionId = getSession();
    const data = {
      sessionId,
      content: chatData,
    };
    dispatch(chatActions.createChat(id, data));
    setChatData("");
  };

  return (
    <Box width={"full"}>
      <Box
      marginBottom={3}
        className="widget-side-div-outer-textarea-in"
        style={{ border: `1px solid ${brandColour}` }}
      >
        <input
          className="widget-side-div-outer-textarea-out"
          value={chatData}
          placeholder={
            widget?.composer_placeholder
              ? widget?.composer_placeholder
              : "Send a message"
          }
          onKeyDown={onKeyDown}
          onChange={(e) => handleInputData(e)}
        />

        {creating ? (
          <Loader isEnd={true} />
        ) : (
          <button
            className="widget-side-div-outer-textarea-cont"
            onClick={() => {
              handleClick();
            }}
          >
            <SendButton imageData={widget?.composer_button} />
          </button>
        )}
      </Box>

      {widget?.disable_branding ? (
       null
      ) : (
        <Box className="widget-side-div-outer-link">
          <div>
          {/* <a
            href="https://doraa.ai/"
            className="widget-side-div-outer-link-list"
            target="_blank"
            rel="noreferrer"
          > */}
            <img src={ai} style={{ height: "20px" }} alt="mvp" />
            <span style={{ color: brandColour }}>
              <span> Powered By </span>
              <span style={{ fontWeight: 500 }} className="font-medium">
                Webspero Solutions
              </span>
            </span>
            </div>
          {/* </a> */}
        </Box>
      )}
    </Box>
  );
};

export default Index;
